import apiCall from '@/utils/api'

const state = {
	wallets: [],
	allWallets: [],
    walletPagination: {
		search: ' ',
		current_page: 1,
		per_page: 0,
	    total: 0,
	    visible: 10
	},
    walletLoader: false
};

const getters = {
	wallets: (state) => state.wallets,
	allWallets: (state) => state.allWallets,
    walletLoader: (state) => state.walletLoader,
    walletPagination: (state) => state.walletPagination
}

const actions = {
	async fetchAllWallets({commit}, page) {
		const response = await apiCall({url: `/api/wallets?type=individual`, method: 'GET' });
		commit('setAllWallets', response)
        commit('stopLoader', response)
	},
    async fetchWallets({commit}, page) {
		const response = await apiCall({url: `/api/wallets?type=admin&page=${page}`, method: 'GET' });
		commit('setWallets', response)
        commit('stopLoader', response)
	},
    async filterWallets({commit, state},resp){
		commit('setWallets', resp)
	},
	async startWalletLoader({commit, state},resp){
		commit('startLoader', resp)
	},
	async stopWalletLoader({commit, state},resp){
		commit('stopLoader', resp)
	},
};

const mutations = {
	setWallets: (state, wallets) => {
		state.wallets = wallets.data
		state.walletPagination.current_page = wallets.current_page
		state.walletPagination.total = wallets.total
		state.walletPagination.per_page = wallets.per_page
	},
	setAllWallets: (state, wallets) => {
		state.allWallets = wallets
	},
    startLoader: (state) => state.walletLoader = true,
	stopLoader: (state) => state.walletLoader = false,
};

export default {
	state,
	getters,
	actions,
	mutations
}
